import { z } from "zod";

/**
 * 連携不可の理由コード。列挙外の値はバックエンドとの契約崩れとして実行時に弾く。
 */
export const transferReasonCodeSchema = z.enum([
  "NOT_CONNECTED",
  "REAUTHORIZATION_REQUIRED",
  "NO_SALESFORCE_RECORD",
  "PICTURE_REQUEST_IN_PROGRESS",
  "ANALYSIS_IN_PROGRESS",
  "ANALYSIS_FAILED",
  "NO_TRANSFERABLE_REAL_ESTATE",
  "EXCEEDS_MAX_COUNT",
  "TRANSFER_IN_PROGRESS",
  "ALREADY_TRANSFERRED",
]);

/**
 * 連携ジョブのワイヤ値。バックエンドの`SalesforceDataTransfer.Status`（DBの値）と同一で、
 * 変換層は設けない。
 */
export const transferStatusSchema = z.enum([
  "PENDING",
  "RUNNING",
  "SUCCEEDED",
  "FAILED",
]);

const transferEligibilityRealEstateSchema = z.object({
  uniqueId: z.string(),
  name: z.string(),
  isTransferable: z.boolean(),
  reasonCode: transferReasonCodeSchema.nullable(),
  reasonMessage: z.string().nullable(),
});

const latestTransferSchema = z.object({
  transferId: z.number(),
  status: transferStatusSchema,
});

const transferEligibilityResultSchema = z.object({
  pictureRequestId: z.number(),
  isTransferable: z.boolean(),
  reasonCode: transferReasonCodeSchema.nullable(),
  reasonMessage: z.string().nullable(),
  transferableCount: z.number(),
  totalCount: z.number(),
  maxTransferableCount: z.number(),
  latestTransfer: latestTransferSchema.nullable(),
  // 一覧画面（`includeRealEstates`を送らない場合）にはnullが返るため、undefinedと合わせて許容する。
  realEstates: z.array(transferEligibilityRealEstateSchema).nullish(),
});

/**
 * `GET /salesforce/data-transfers/eligibility/` の契約検証スキーマ。
 * OpenAPIからの型生成が無いため、実行時検証で契約の崩れを検知する
 * （`useAcquireBookStatus.ts`の前例に倣う）。
 */
export const transferEligibilityResponseSchema = z.object({
  results: z.array(transferEligibilityResultSchema),
});

/**
 * `GET /salesforce/data-transfers/{transferId}/` の契約検証スキーマ。
 *
 * `status`はポーリングの停止条件であり、想定外の値が来ると5秒間隔で永久に回り続ける。
 * タイムアウトも無いため、ここで確実に弾く。
 */
export const getDataTransferResponseSchema = z.object({
  status: transferStatusSchema,
  transferredAt: z.string().nullable(),
  errorMessage: z.string().nullable(),
});

/**
 * `POST /salesforce/data-transfers/` の`202`レスポンスの契約検証スキーマ。
 *
 * `transferId`はこの後のポーリングキーになる。欠落・型崩れのまま進めるとポーリングが始まらず、
 * ボタンが進行中表示のまま戻らないため、ここで確実に弾く。
 */
export const postDataTransferResponseSchema = z.object({
  transferId: z.number(),
  status: transferStatusSchema,
});
